import type { InventoryItem, StockMovement } from '@/api/types'

/**
 * 物料 + 出入库记录 Mock 数据
 * 物料: 9条，覆盖教材/文具/礼品类别
 * 出入库: 15条，覆盖入库/出库/盘点
 */

const now = '2025-06-15T00:00:00Z'

// ===== 物料 =====

export const mockInventoryItems: InventoryItem[] = [
  {
    id: 'item-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '幼儿英语教材（上）',
    sku: 'BK-EN-001',
    category: '教材',
    unit: '本',
    quantity: 120,
    minQuantity: 30,
    unitPriceMinor: 3500, // 35元
    currency: 'CNY',
    thumbnail: 'https://placeholder.co/120x120/FF7D00/FFF?text=EN1',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'item-002',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '幼儿英语教材（下）',
    sku: 'BK-EN-002',
    category: '教材',
    unit: '本',
    quantity: 85,
    minQuantity: 30,
    unitPriceMinor: 3500,
    currency: 'CNY',
    thumbnail: 'https://placeholder.co/120x120/FF7D00/FFF?text=EN2',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'item-003',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '数学思维练习册',
    sku: 'BK-MA-001',
    category: '教材',
    unit: '本',
    quantity: 25,
    minQuantity: 40,
    unitPriceMinor: 2800,
    currency: 'CNY',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'item-004',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '铅笔（2B）',
    sku: 'ST-PE-001',
    category: '文具',
    unit: '支',
    quantity: 300,
    minQuantity: 100,
    unitPriceMinor: 150,
    currency: 'CNY',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'item-005',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '橡皮擦',
    sku: 'ST-ER-001',
    category: '文具',
    unit: '块',
    quantity: 200,
    minQuantity: 50,
    unitPriceMinor: 100,
    currency: 'CNY',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'item-006',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '笔记本（A5）',
    sku: 'ST-NB-001',
    category: '文具',
    unit: '本',
    quantity: 150,
    minQuantity: 50,
    unitPriceMinor: 500,
    currency: 'CNY',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'item-007',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '品牌书包',
    sku: 'GF-BG-001',
    category: '礼品',
    unit: '个',
    quantity: 40,
    minQuantity: 20,
    unitPriceMinor: 8800,
    currency: 'CNY',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'item-008',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '定制水杯',
    sku: 'GF-CU-001',
    category: '礼品',
    unit: '个',
    quantity: 60,
    minQuantity: 30,
    unitPriceMinor: 2500,
    currency: 'CNY',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'item-009',
    brandId: 'b-001',
    campusId: 'c-003',
    name: '美术画具套装',
    sku: 'BK-AR-001',
    category: '教材',
    unit: '套',
    quantity: 35,
    minQuantity: 15,
    unitPriceMinor: 12000,
    currency: 'CNY',
    createdAt: '2025-01-10T00:00:00Z',
    updatedAt: now,
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
]

// ===== 出入库记录 =====

export const mockStockMovements: StockMovement[] = [
  {
    id: 'mv-001',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-001',
    itemName: '幼儿英语教材（上）',
    type: 'IN',
    quantity: 100,
    reason: '采购入库',
    operatorId: 'u-admin-001',
    operatorName: '管理员',
    recorderId: 'u-admin-001',
    recorderName: '管理员',
    voucherUrl: 'https://placeholder.co/200x200/67C23A/FFF?text=RCPT',
    createdAt: '2025-01-15T09:00:00Z',
    updatedAt: '2025-01-15T09:00:00Z',
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'mv-002',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-001',
    itemName: '幼儿英语教材（上）',
    type: 'OUT',
    quantity: 30,
    reason: '学员领用',
    operatorId: 's-002',
    operatorName: '李娜',
    recorderId: 'u-admin-001',
    recorderName: '管理员',
    createdAt: '2025-02-01T10:00:00Z',
    updatedAt: '2025-02-01T10:00:00Z',
    createdBy: 's-002',
    updatedBy: 's-002',
  },
  {
    id: 'mv-003',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-001',
    itemName: '幼儿英语教材（上）',
    type: 'OUT',
    quantity: 25,
    reason: '学员领用',
    operatorId: 's-002',
    operatorName: '李娜',
    createdAt: '2025-03-01T10:00:00Z',
    updatedAt: '2025-03-01T10:00:00Z',
    createdBy: 's-002',
    updatedBy: 's-002',
  },
  {
    id: 'mv-004',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-002',
    itemName: '幼儿英语教材（下）',
    type: 'IN',
    quantity: 100,
    reason: '采购入库',
    operatorId: 'u-admin-001',
    operatorName: '管理员',
    createdAt: '2025-01-15T09:00:00Z',
    updatedAt: '2025-01-15T09:00:00Z',
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'mv-005',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-002',
    itemName: '幼儿英语教材（下）',
    type: 'OUT',
    quantity: 15,
    reason: '学员领用',
    operatorId: 's-002',
    operatorName: '李娜',
    createdAt: '2025-02-15T10:00:00Z',
    updatedAt: '2025-02-15T10:00:00Z',
    createdBy: 's-002',
    updatedBy: 's-002',
  },
  {
    id: 'mv-006',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-003',
    itemName: '数学思维练习册',
    type: 'IN',
    quantity: 50,
    reason: '采购入库',
    operatorId: 'u-admin-001',
    operatorName: '管理员',
    createdAt: '2025-01-20T09:00:00Z',
    updatedAt: '2025-01-20T09:00:00Z',
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'mv-007',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-003',
    itemName: '数学思维练习册',
    type: 'OUT',
    quantity: 25,
    reason: '学员领用',
    operatorId: 's-003',
    operatorName: '王芳',
    createdAt: '2025-02-20T10:00:00Z',
    updatedAt: '2025-02-20T10:00:00Z',
    createdBy: 's-003',
    updatedBy: 's-003',
  },
  {
    id: 'mv-008',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-003',
    itemName: '数学思维练习册',
    type: 'ADJUST',
    quantity: -2,
    reason: '盘点损耗',
    operatorId: 'u-admin-001',
    operatorName: '管理员',
    createdAt: '2025-03-31T16:00:00Z',
    updatedAt: '2025-03-31T16:00:00Z',
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'mv-009',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-004',
    itemName: '铅笔（2B）',
    type: 'IN',
    quantity: 500,
    reason: '采购入库',
    operatorId: 'u-admin-001',
    operatorName: '管理员',
    createdAt: '2025-01-10T09:00:00Z',
    updatedAt: '2025-01-10T09:00:00Z',
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'mv-010',
    brandId: 'b-001',
    campusId: 'c-001',
    itemId: 'item-004',
    itemName: '铅笔（2B）',
    type: 'OUT',
    quantity: 200,
    reason: '课堂领用',
    operatorId: 's-003',
    operatorName: '王芳',
    createdAt: '2025-03-01T10:00:00Z',
    updatedAt: '2025-03-01T10:00:00Z',
    createdBy: 's-003',
    updatedBy: 's-003',
  },
  {
    id: 'mv-011',
    brandId: 'b-001',
    campusId: 'c-002',
    itemId: 'item-007',
    itemName: '品牌书包',
    type: 'IN',
    quantity: 50,
    reason: '采购入库',
    operatorId: 'u-admin-001',
    operatorName: '管理员',
    createdAt: '2025-02-01T09:00:00Z',
    updatedAt: '2025-02-01T09:00:00Z',
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'mv-012',
    brandId: 'b-001',
    campusId: 'c-002',
    itemId: 'item-007',
    itemName: '品牌书包',
    type: 'OUT',
    quantity: 10,
    reason: '新签赠品',
    operatorId: 's-005',
    operatorName: '陈静',
    createdAt: '2025-03-15T10:00:00Z',
    updatedAt: '2025-03-15T10:00:00Z',
    createdBy: 's-005',
    updatedBy: 's-005',
  },
  {
    id: 'mv-013',
    brandId: 'b-001',
    campusId: 'c-002',
    itemId: 'item-008',
    itemName: '定制水杯',
    type: 'IN',
    quantity: 80,
    reason: '采购入库',
    operatorId: 'u-admin-001',
    operatorName: '管理员',
    createdAt: '2025-02-01T09:00:00Z',
    updatedAt: '2025-02-01T09:00:00Z',
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
  {
    id: 'mv-014',
    brandId: 'b-001',
    campusId: 'c-002',
    itemId: 'item-008',
    itemName: '定制水杯',
    type: 'OUT',
    quantity: 20,
    reason: '活动赠品',
    operatorId: 's-005',
    operatorName: '陈静',
    createdAt: '2025-04-01T10:00:00Z',
    updatedAt: '2025-04-01T10:00:00Z',
    createdBy: 's-005',
    updatedBy: 's-005',
  },
  {
    id: 'mv-015',
    brandId: 'b-001',
    campusId: 'c-003',
    itemId: 'item-009',
    itemName: '美术画具套装',
    type: 'IN',
    quantity: 40,
    reason: '采购入库',
    operatorId: 'u-admin-001',
    operatorName: '管理员',
    createdAt: '2025-03-01T09:00:00Z',
    updatedAt: '2025-03-01T09:00:00Z',
    createdBy: 'u-admin-001',
    updatedBy: 'u-admin-001',
  },
]
